import { render, staticRenderFns } from "./Suggested.vue?vue&type=template&id=6785430f&scoped=true"
import script from "./Suggested.vue?vue&type=script&lang=js"
export * from "./Suggested.vue?vue&type=script&lang=js"
import style0 from "./Suggested.vue?vue&type=style&index=0&id=6785430f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6785430f",
  null
  
)

export default component.exports